export default "__VITE_ASSET__ef639806__"